import { assertNever } from './util/assertNever';

export interface AppConfig {
  appUUID: string;
  debugHttp: boolean;
  autoSignIn: boolean;
  baseName: string;
  apiUrl: string;
  redirectUrl: string;
  requestTimeout: number;
  answerTimeout: number;
  headwayAccount: string;
  amplitudeApiKey?: string;
}

type EnvType = 'local' | 'dev' | 'prod' | 'gw' | 'preview';

export const getAppEnv = (): EnvType => {
  const currentHost = window.location.hostname;

  if (/.*localhost.*/.test(currentHost)) {
    return 'local';
  } else if (/.*-dev.*/.test(currentHost)) {
    return 'dev';
  } else if (/.*\.dev.blankslatetechnologies\.com.*/.test(currentHost)) {
    return 'preview';
  } else if (/.*\.blankslatetechnologies\.com.*/.test(currentHost)) {
    return 'prod';
  } else {
    return 'gw';
  }
};

const gwConfig: AppConfig = {
  answerTimeout: 60000,
  apiUrl:
    // biome-ignore lint/suspicious/noExplicitAny: window.API_URL is injected at runtime
    (window as any).API_URL || `https://${window.location.hostname}/sreo/v0.1`,
  appUUID: 'ios-test-app',
  autoSignIn: true,
  baseName: '/app',
  debugHttp: false,
  headwayAccount: 'Jljo4x',
  redirectUrl: 'https://app.blankslatetechnologies.com/',
  requestTimeout: 30000,
};

const releaseConfig: AppConfig = {
  amplitudeApiKey: '1ff1e794afc1bc95f6d32874a8fa0995',
  answerTimeout: 60000,
  // biome-ignore lint/suspicious/noExplicitAny: window.API_URL is injected at runtime
  apiUrl: (window as any).API_URL || 'https://svc.blankslatetechnologies.com/sreo/v0.1',
  appUUID: 'ios-test-app',
  autoSignIn: true,
  baseName: '/app',
  debugHttp: false,
  headwayAccount: 'Jljo4x',
  redirectUrl: 'https://app.blankslatetechnologies.com/',
  requestTimeout: 30000,
};

const previewConfig: AppConfig = {
  ...releaseConfig,
  amplitudeApiKey: '74f7412419133e093accca6a151559da',
  apiUrl: process.env.REACT_APP_API_URL || `https://${window.location.hostname}/sreo/v0.1`,
};

const devConfig: AppConfig = {
  ...releaseConfig,
  amplitudeApiKey: '74f7412419133e093accca6a151559da',
  // biome-ignore lint/suspicious/noExplicitAny: window.API_URL is injected at runtime
  apiUrl: (window as any).API_URL || 'https://svc-dev.blankslatetechnologies.com/sreo/v0.1',
  headwayAccount: '',
  redirectUrl: 'https://app-dev.blankslatetechnologies.com/',
};

const localConfig: AppConfig = {
  ...devConfig,
  apiUrl: process.env.BACKEND_URL ? '/sreo/v0.1' : devConfig.apiUrl,
  redirectUrl: 'http://localhost:3000/app/',
};

const getConfig = (): AppConfig => {
  const env: EnvType = getAppEnv();
  let base: AppConfig;
  switch (env) {
    case 'local':
      base = localConfig;
      break;
    case 'preview':
      base = previewConfig;
      break;
    case 'dev':
      base = devConfig;
      break;
    case 'prod':
      base = releaseConfig;
      break;
    case 'gw':
      base = gwConfig;
      break;
    default:
      return assertNever(env);
  }
  const override = (window as unknown as { __APP_CONFIG__?: Partial<AppConfig> }).__APP_CONFIG__;
  return override ? { ...base, ...override } : base;
};

export const isDev = process.env.NODE_ENV === 'development';

export default getConfig();
